import { useMemo, useState, useRef, useEffect, useCallback } from "react";

import {
  Box,
  // Grid,
  // List,
  HStack,
  // VStack,
  Heading,
  CircularProgress,
  Container,
  // Breadcrumb,
  // BreadcrumbItem,
  Grid,
  Button,
  // Divider,
  Text,
  Stack,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { ReactComponent as Circle } from "assets/svg/paint-circle.svg";

// import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import PartialEarn from "./PartialEarn";
// import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
// import InvestWallet from "components/InvestWallet/InvestWallet";
// import CoinPerformance from "components/CoinPerformance/CoinPerformance";
// import PaymentDueGauge from "components/PaymentDueGauge/PaymentDueGauge";
// import PriceChart from "components/Charts/PriceChart";

// import { ReactComponent as HistoryMeter } from "assets/svg/history-meter.svg";
// import { ReactComponent as PerformanceChart } from "assets/svg/inpl-chart.svg";
// import { ReactComponent as EmptyTransactionState } from "assets/svg/empty-inpl.svg";

import {
  useGetLoanRecordsQuery,
  useGetLoanBalanceQuery,
  // useGetLoanProfileQuery,
} from "services/walletApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// import { useGetCoinToUsdRateQuery } from "services/rateApi";

// import isEmpty from "lodash/isEmpty";
// import toLower from "lodash/toLower";
// import { format, parseISO } from "date-fns";
// import formatter from "util/formatter";
// import toUpper from "lodash/toUpper";
// import take from "lodash/take";

// import constant from "config/constant";

function EarnItem(props) {
  const { title, subtitle, ring, ...xprops } = props;

  return (
    <Button
      minW="fit-content"
      w="100%"
      minH="fit-content"
      h="71px"
      maxH="fit-content"
      p="20px 28px"
      borderRadius="12px"
      d="block"
      border="1px solid transparent"
      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
      _hover={{ shadow: "0 0 0 3px var(--focusColor)" }}
      _active={{ shadow: "0 0 0 3px var(--focusColor)" }}
      bg="#3689F8"
      color="white"
      overflow="hidden"
      {...xprops}
    >
      {ring && (
        <Box
          borderRadius="10px"
          pos="absolute"
          left="50%"
          bottom="-70px"
          opacity="0.2"
          overflow="hidden"
          transform="translateX(-50%)"
          // maxH="80px"
        >
          <Box w="100px" as={Circle} color="#D9DBE9" />
        </Box>
      )}

      <HStack justifyContent="space-between">
        <HStack>
          <Text fontSize="20px" color="inherit">
            {title}
          </Text>

          {subtitle && (
            <Text ml="10px" fontSize="12px" color="inherit" fontWeight="400">
              {subtitle}
            </Text>
          )}
        </HStack>

        <Box fontSize="24px" as={ChevronRightIcon} color="inherit" />
      </HStack>
    </Button>
  );
}

export default function Earn(props) {
  const currentPage = "Earn";

  const history = useHistory();
  const { data, isLoading } = useGetLoanRecordsQuery();

  console.log("HISTORY DATA", data);

  const coinName = useCallback((coin) => {
    const map = {
      [coin]: coin,
      tbtc: "btc",
      teth: "eth",
    };

    return map[coin];
  }, []);

  const { data: loanBalanceData /*isLoading: isBalanceLoading*/ } =
    useGetLoanBalanceQuery();

  const isBalanceLoaded = useRef(false);

  const [state, setState] = useState();

  const handleState = (newState) => setState({ ...state, ...newState });

  const loanBalance = useMemo(() => {
    const values = loanBalanceData?.arraySums[0];
    return values;
  }, [loanBalanceData]);

  useEffect(() => {
    if (loanBalance && !isBalanceLoaded.current) {
      handleState({ coin: coinName(loanBalance?.coin) });
      isBalanceLoaded.current = true;
    }

    // eslint-disable-next-line
  }, [loanBalance, isBalanceLoaded]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <HStack>
                <Heading fontSize="3xl">Earn</Heading>
                {isLoading && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                )}
              </HStack>

              {/* <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/wallet">Wallet</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="/dashboard/wallet/earn">
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to={`/dashboard/wallet/earn`}>
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb> */}
            </Box>

            {/* <PartialEarn
              coin={constant.supportedStakableCoins[0]}
              availableCoins={constant.supportedStakableCoins}
            /> */}
            <Grid
              templateColumns="repeat(2, 1fr)"
              mt="40px"
              h="60vh"
              gap="40px"
            >
              <HStack alignItems="flex-start" justifyContent="space-between">
                <Box
                  w="100%"
                  bg="white"
                  border="1px solid #EDEBF9"
                  borderRadius="16px"
                  p="44px"
                  mr="40px"
                  mt="20px"
                >
                  <Stack>
                    <EarnItem
                      title="Staking"
                      ring
                      onClick={() => {
                        history.push(`/dashboard/earn/staking`);
                      }}
                    />
                    <EarnItem
                      title="Savings"
                      subtitle="(coming soon)"
                      ring
                      bg="#45B68D"
                    />
                    <EarnItem
                      title="De-fi Savings"
                      subtitle="(coming soon)"
                      bg="#3151AB"
                      ring
                    />
                  </Stack>
                </Box>

                {/* <Divider orientation="vertical" color="#D9DBE9" mr="20px" /> */}
              </HStack>

              {/* <Box mt="20px">
                <Stack mr="80px">
                  <EarnItem
                    title="Fixed Staking"
                    bg="white"
                    color="#14142B"
                    borderColor="#D9DBE9"
                    onClick={() => {
                      history.push(`/dashboard/earn/fixed`);
                    }}
                  />
                  <EarnItem
                    title="Flexible Staking"
                    subtitle="(coming soon)"
                    bg="white"
                    color="#14142B"
                    borderColor="#D9DBE9"
                  />
                </Stack>
              </Box> */}
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
